import { render } from "./HomeIcon2.vue?vue&type=template&id=55648c90"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/HomeIcon2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55648c90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55648c90', __exports__)) {
    api.reload('55648c90', __exports__)
  }
  
  module.hot.accept("./HomeIcon2.vue?vue&type=template&id=55648c90", () => {
    api.rerender('55648c90', render)
  })

}


export default __exports__